import i18n from 'modules/core/lib/i18n'

export const getPresets = () => [
  {
    label: i18n.t('trainings.training_requests.requests.datatable.pending'),
    filter: { status: ['review'] },
  },
  {
    label: i18n.t('trainings.training_requests.requests.datatable.approved'),
    filter: { status: ['approved'] },
  },
  {
    label: i18n.t('trainings.training_requests.requests.datatable.rejected'),
    filter: { status: ['rejected'] },
  },
]
